import { HIGHLIGHTS } from "../../lib/data";

/**
 * Highlights — light editorial numbered grid.
 * No overline labels, no decorative lines above headings.
 */
export default function Highlights() {
  return (
    <section
      id="highlights"
      data-testid="highlights-section"
      className="bg-[#EBE7DF] text-[#1A362D] py-20 md:py-32"
    >
      <div className="max-w-[100rem] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-end gap-8 lg:gap-10 mb-14 md:mb-20">
          <h2 className="reveal lg:col-span-7 font-serif-display text-[2.5rem] sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight font-light">
            Everything you need.
            <br />
            <em className="font-normal">And nothing you don&apos;t.</em>
          </h2>
          <p className="reveal lg:col-span-5 text-[#3A453B] text-base md:text-lg leading-relaxed max-w-md">
            Six reasons Amarja Hills is unlike any other plotted development
            between Mumbai and Pune.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#1A362D]/15">
          {HIGHLIGHTS.map((h, idx) => (
            <div
              key={h.id}
              data-testid={`highlight-${h.id}`}
              className="reveal bg-[#F7F5F0] p-7 md:p-9 group hover:bg-[#FFFCF6] transition-colors duration-500"
              style={{ transitionDelay: `${idx * 70}ms` }}
            >
              <div className="flex items-baseline justify-between mb-6 md:mb-8">
                <span className="font-serif-display text-3xl md:text-4xl text-[#987F53] italic font-light">
                  {String(idx + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-serif-display text-2xl md:text-[1.75rem] text-[#1A362D] leading-tight tracking-tight">
                {h.title}
              </h3>
              <p className="mt-3 text-sm text-[#4A524D] leading-relaxed">
                {h.note}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
